import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faPowerOff } from "@fortawesome/free-solid-svg-icons"

export const PowerOff = (props) => {
  return <FontAwesomeIcon faIcon={faPowerOff} {...props} />
}
